<mat-tab-group [(selectedIndex)]="selectedIndex" dynamicHeight="true">
  <mat-tab
    [label]="(service.title$ | async) ?? ''"
    fxLayout="column"
    fxLayoutAlign="start stretch"
  >
    <!-- <pcp-customer-select
      *ngIf="config.multiTenant"
      fxFlexAlign="center"
      [value]="permissions.selectedCustomer | async"
      (valueChange)="selectCustomer($event)"
    ></pcp-customer-select> -->
    <ng-content select="[pcpStartItems]"></ng-content>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon>format_color_fill</mat-icon>
            <span i18n>Themes</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <button
          [id]="theme"
          style="margin-bottom: 5px"
          *ngFor="let theme of availableThemes"
          mat-menu-item
          (click)="changeTheme.emit(theme)"
        >
          <pcp-theme-select [theme]="theme.themeName"></pcp-theme-select>
        </button>
      </mat-expansion-panel>
    </mat-accordion>
    <ng-container>
      <button
        *ngFor="let action of actions"
        (click)="
          breakPointObserver.isMatched('(max-width: 599px)') ||
          action.toggleSideMenu
            ? service.toggleSideMenu(null)
            : ''
        "
        [id]="action.id"
        mat-menu-item
        [routerLink]="action.routerLink"
      >
        <!-- <mat-icon *ngIf="!action.fontSet">{{ action.icon }}</mat-icon> -->
        <mat-icon [fontSet]="action.fontSet ?? ''">{{ action.icon }}</mat-icon>
        <span>{{ action.title }}</span>
      </button>
    </ng-container>
    <!-- <button
      *ngIf="!config.disableAuthentication"
      id="logout"
      (click)="service.toggleSideMenu()"
      mat-menu-item
      routerLink="/login"
    >
      <mat-icon>close</mat-icon>
      <span i18n>Logout</span>
    </button> -->
    <ng-content select="[pcpEndItems]"></ng-content>
  </mat-tab>
  <mat-tab
    *ngFor="let item of items; trackBy: trackByItems"
    [label]="
      item?.originalItem?.item?.label ? item.originalItem.item!.label : ''
    "
  >
    <div>
      <ng-template
        [cdkPortalOutlet]="item.cp"
        (attached)="portalAttached(item, $event)"
      >
      </ng-template>
    </div>
  </mat-tab>
</mat-tab-group>
